import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const SearchingAlgorithms = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Searching Algorithms"
    videos={[
      "https://www.youtube.com/embed/C46QfTjVCNU",
      "https://www.youtube.com/embed/C2apEw9pgtw",
    ]}
    takeaways={[
      { text: "Learn the pseudocodes, advantages, and time complexity of both the searching algorithms." }
    ]}
    questions={[
      "Having an array of unsorted elements, define an algorithm to search an element using binary search, and write the best and worst case of time-complexity with an example.",
      "Design the pseudocode having time complexity not more than O(Log2N) for searching an ITEM in a given array. Verify that it meets the criteria for the said time complexity.",
      "Explain the working principle of Binary search algorithm in recursive method for the given array of values 78, 23, 67, 88, 12, 38, 56, 10. Assume that the element to be searched, K = 56."
    ]}
    exampleVideos={[]}
  />
);
}

export default SearchingAlgorithms;
